import React from 'react';
const links = [{
  label: 'El programa',
  href: '#programa'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Precio',
  href: '#precio'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Footer() {
  return <footer className="bg-navy py-14" data-id="element-127" data-mp="2f3ijfu3yjajy">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-128" data-mp="2f2h7zoj14m1p">
        <div className="grid gap-10 lg:grid-cols-3 lg:items-start" data-id="element-129" data-mp="2a71tcud76m48">
          <div data-id="element-130" data-mp="1mfmpuy9opyre">
            <span className="text-[13px] font-bold uppercase tracking-[0.2em] text-ice" data-id="element-131" data-mp="1mh7k0ms37foq">
              Atleta<span className="text-gold" data-id="element-132" data-mp="1hi4d0wsjqze4"> Corporativo™</span>
            </span>
            <p className="mt-4 max-w-xs text-[15px] leading-[1.7] text-cool" data-id="element-133" data-mp="1w6hbc0f3wubs">
              El sistema de biohacking corporativo N°1 para profesionales
              argentinos de oficina.
            </p>
          </div>

          <nav aria-label="Secciones" className="lg:justify-self-center" data-id="element-134" data-mp="13omtvd3rvoom">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-135" data-mp="yqtrkv5lbetm">
              {links.map(link => <li key={link.href} data-id="element-136" data-mp="1ei2a7b14zvgs">
                  <a href={link.href} className="text-[13px] font-medium uppercase tracking-[0.1em] text-cool transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-137" data-mp="1eivhcd40cmzg">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <ul className="space-y-2 text-[14px] text-cool lg:justify-self-end lg:text-right" data-id="element-138" data-mp="1s97behk5kvt8">
            <li data-id="element-139" data-mp="vjhl1oit305s">
              <a href="mailto:soporteatletacorporativo@gmail.com" className="transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-140" data-mp="vjzs7g70aysh">
                soporteatletacorporativo@gmail.com
              </a>
            </li>
            <li data-id="element-141" data-mp="14j4rioqe6w5p">@atletacorporativo</li>
            <li data-id="element-142" data-mp="14m90dzesyg2p">
              <a href="https://atleta-corporativo.impultienda.ar" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-143" data-mp="19ipqgz5kb4if">
                atleta-corporativo.impultienda.ar
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-12 border-t border-line pt-8" data-id="element-144" data-mp="1va0lt3cdplvb">
          <p className="text-[13px] leading-[1.7] text-cool" data-id="element-145" data-mp="1v8fqvcm5k0wx">
            © {new Date().getFullYear()} Atleta Corporativo™. Porque rendir al
            máximo en tu carrera no debería costarte la salud, la energía y los
            años con tu familia. Producto digital — no reemplaza consulta médica
            profesional.
          </p>
        </div>
      </div>
    </footer>;
}